import DesktopNavigation from "./DesktopNavigation";
import MobileNavigation from "./MobileNavigation";
import "../Css/Header.css";
export default function Header() {
  return (
    <div className="Header-container">
      <h1 className="logo">تقى أبوراضي</h1>
      <DesktopNavigation />
      <MobileNavigation />
    </div>
  );
}
